import {TagReference} from "../../../services/ApiModels/TagReference";
import AllResultsService from "../../../services/AllResultsService";
import {getAttributes} from "../ImageViewerObject";
import TagUrlLinkService from "../../../services/TagUrlLinkService";
import HierarchyNode from "./HierarchyNode";
import {message} from "antd";

export class ObjectReferenceV2 {
    private _node: HierarchyNode;
    private readonly _tagReference: TagReference;

    constructor(node: HierarchyNode, tagReference: TagReference) {
        this._node = node;
        this._tagReference = tagReference;
    }

    isOnPageReference() {
        const ivResultRef = this._node.hierarchy.imageViewer.toResultReference();
        return this._tagReference.result_reference.result_id === ivResultRef.result_id;
    }

    async getObjectAttributes() {
        let res = await AllResultsService.getAnnotationObject(this._tagReference);
        if (res.data == null) {
            return null;
        } else {
            return getAttributes(res.data);
        }
    }

    open() {
        TagUrlLinkService.generateTagLinkByResultReference(
            this._tagReference.result_reference.result_id,
            this._tagReference.result_reference.is_final,
            this._tagReference.tag_number,
            this._tagReference.tag_id,
            `?hierarchy_id=${this._node.hierarchy.id}`,
        ).then(tagLink => {
            this._node.hierarchy.imageViewer.props.history.push(tagLink);
        }).catch(() => {
            message.error('Failed to get tag reference');
        });
    }
}